<template>
  <div>
    <ModuleHeader>Reporte rendimiento de horas</ModuleHeader>
    <v-row>
      <v-col md="6" cols="12" class="input">
        <label>Fecha inicial</label>
        <Datepicker
          @selected="selectDate"
          :value="input_date.format('MM/DD/YYYY')"
        ></Datepicker>
      </v-col>
      <v-col md="6" cols="12" class="input">
        <label>Fecha final</label>
        <Datepicker
          @selected="selectDateFinal"
          :disabled-dates="disableDates"
          :value="input_date_final.format('MM/DD/YYYY')"
        ></Datepicker>
      </v-col>
      <v-col md="6" cols="6" class="mb-5">
        <v-btn @click="getReservas()" color="green" dark>
          Buscar
        </v-btn>
      </v-col>
      <v-col md="6" cols="6" class="mb-5 text-right">
        <v-btn @click="generatePdf()" color="red" dark>
          Generar pdf
        </v-btn>
      </v-col>
    </v-row>

    <v-simple-table>
      <thead>
        <tr>
          <th class="text-center">Hora</th>
          <th class="text-center">Actual</th>
          <th class="text-center">Potencial</th>
          <th class="text-right">% Reservado</th>
          <th class="text-right">% Disponible</th>
        </tr>
      </thead>
      <tbody class="text-center">
        <tr v-for="time in times" :key="time.time">
          <td width="15%" style="font-size: 18px;">
            {{ time.time }} - {{ time.horaLimite }}
          </td>
          <td>{{ time.ocupado }}</td>
          <td>{{ time.disponible }}</td>
          <td class="text-right">
            {{ $pgsHelper.formatNumber(time.booked) }}%
          </td>
          <td class="text-right">
            {{ $pgsHelper.formatNumber(time.unbooked) }}%
          </td>
        </tr>
        <tr>
          <td>
            <b>Total</b>
          </td>
          <td>
            <b>{{ sumaActual.totalActual }}</b>
          </td>
          <td>
            <b>{{ sumaActual.totalPotencial }}</b>
          </td>
          <td class="text-right">
            <b>{{ $pgsHelper.formatNumber(sumaActual.apartado) }}%</b>
          </td>
          <td class="text-right">
            <b> {{ $pgsHelper.formatNumber(sumaActual.noApartado) }}%</b>
          </td>
        </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import TarifasClass from "../../clases/Tarifa.js";
import pdfmake from "pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import ReporteOcupacion from "../../clases/PdfMakers/ReporteOcupacion.js";
pdfmake.vfs = pdfFonts.pdfMake.vfs;

export default {
  name: "ReporteOcupacionCampo",
  components: {
    Datepicker,
  },
  data() {
    return {
      reservations: [],
      input_date: moment(),
      input_date_final: moment(),
      hoteles: [],
      concierges: [],
      tarifarios: [],
      status: [],
      times: [],
      TeeSheet: {
        slots: [0, 1, 2, 3],
      },
      initTime: new moment("06:00", "HH:mm"),
      endTime: new moment("18:00", "HH:mm"),
      totalPlayers: 0,
      totalReservas: 0,
      totalCancelados: 0,
      loadingData: false,
      daysRule: null,
    };
  },
  methods: {
    async generatePdf() {
      let mainData = {
        FI: this.input_date.format("DD/MM/YYYY"),
        FF: this.input_date_final.format("DD/MM/YYYY"),
        FG: new moment().format("DD/MM/YYYY"),
        HG: new moment().format("HH:mm:ss"),
        TITLE: "Reporte Rendimiento de Horas",
        data: this.times,
        totales: this.sumaActual,
      };
      let docData = ReporteOcupacion.getDocData(mainData);
      pdfmake.createPdf(docData).open();
    },
    async getDaysRules() {
      try {
        const snapshot = await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "RVA/Configuracion/" + "Golf" + "/Calendario"
        );
        let configFechas = snapshot.val();

        this.initTime = new moment(snapshot.val().Hora_Apertura, "HH:mm:ss");
        this.endTime = new moment(snapshot.val().Hora_Cierre, "HH:mm:ss");

        this.daysRule = configFechas;
      } catch (e) {
        console.log(e);
      }
    },
    selectDate(arg) {
      this.input_date = moment(arg);
      this.input_date_final = moment(arg);
    },
    selectDateFinal(arg) {
      this.input_date_final = moment(arg);
    },

    async getReservas() {
      this.loadingData = true;
      const startDate = this.input_date.format("YYYY-MM-DD");
      const endDate = this.input_date_final.format("YYYY-MM-DD");
      const end = endDate.replace(/.$/, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 1)
      );
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      let filters = [
        firestore.where("RF.FI", ">=", startDate),
        firestore.where("RF.FI", "<", end),
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ];

      //  if (this.selectedHotel !== "") {
      //    if (this.selectedHotel !== "Admin" && this.selectedHotel !== "Web") {
      //      let hotel = this.$pgsHelper.getById(
      //        this.hoteles,
      //        "Codigo",
      //        this.selectedHotel
      //      );
      //      filters.push(firestore.where("Mayorista.Id", "==", hotel.id));
      //    } else {
      //      filters.push(firestore.where("Creador", "==", this.selectedHotel));
      //    }

      filters.push(firestore.where("Departamento", "==", "Golf"));

      const data = await firestore.queryBuilder("RVA_Reservas", filters);

      this.reservations = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });

      this.showEstad = true;
      this.loadingData = false;

      this.reservations.forEach((element) => {
        if (element.Tarifas) {
          let tarifas = Object.entries(element.Tarifas);
          element.TarifasList = tarifas;
        }
      });
      // console.log(this.reservations);
      this.buildTimesData();
    },

    buildTimesData() {
      try {
        let initTime = new moment(this.initTime.format("HH:mm"), "HH:mm");
        let endTime = new moment(this.endTime.format("HH:mm"), "HH:mm");

        
        
        let diaSiguiente = new moment(this.input_date_final.format('YYYY-MM-DD'), 'YYYY-MM-DD')
        diaSiguiente.add(1,'day')
        const diasDiferencias = diaSiguiente.startOf('day').diff(this.input_date.startOf('day'), 'days')
        
     

        let auxDate = initTime;
        this.times = [];
        let hourGroups = {};

        while (auxDate.format("HH:mm") <= endTime.format("HH:mm")) {
          let personas = 0;
          this.reservas_comp.forEach((element) => {
            let time = new moment(element.time_format, "HH:mm:ss");
            if (time.format("HH:mm") == auxDate.format("HH:mm")) {
              if (element.Estatus != "Cancelled") {
                personas++;
              }
            }
          });

          let intervalo = new moment(
            this.daysRule.Intervalo_TeeTimes,
            "HH:mm:ss"
          );

          let hour = auxDate.format("HH:00");

          let limitHour = auxDate.format("HH:59");

          if (!hourGroups[hour]) {
            hourGroups[hour] = {
              horaLimite: limitHour,
              ocupado: 0,
              disponible: 0,
            };
          }
          hourGroups[hour].ocupado += personas;
          auxDate = auxDate.add(Number(intervalo.format("mm")), "minutes");
        }

        Object.keys(hourGroups).forEach((hour) => {
          let totalSlotsPerHour = diasDiferencias * 24;
          hourGroups[hour].disponible =
            totalSlotsPerHour - hourGroups[hour].ocupado;

          let booked = (hourGroups[hour].ocupado / totalSlotsPerHour) * 100;

          let unbooked = 100 - booked;

          let horaLimite = hourGroups[hour].horaLimite;

          this.times.push({
            time: hour,
            horaLimite: horaLimite,
            ocupado: hourGroups[hour].ocupado,
            disponible: hourGroups[hour].disponible,
            booked: booked,
            unbooked: unbooked,
          });
        });

        this.loadingData = false;
      } catch (e) {
        this.loadingData = false;
      }
    },

    async getHoteles() {
      //obtiene el listado de hoteles afiliados
      await this.$store.getters.getFirebaseApp.database.queryBuilderListener(
        "RVA/Mayoristas/Coleccion",
        null,
        (snapshot) => {
          this.hoteles = [];
          let arrayHoteles = Object.entries(snapshot.val());
          arrayHoteles.forEach((element) => {
            this.hoteles.push({ id: element[0], ...element[1] });
          });
        }
      );
    },
    async getConcierges() {
      const data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "RVA/Concierge"
      );
      if (!data.exists()) {
        return false;
      }
      let concierges = Object.entries(data.val());
      let conciergesData = [{ id: "All", nom: "Todos" }];
      concierges.forEach(function(element) {
        conciergesData.push({
          id: element[0],
          ...element[1],
        });
      });
      this.concierges = conciergesData;
    },
    async getComboTarifarios() {
      /* obtiene el listado de tarifas para armado del comboBox */
      let tarifarios = await TarifasClass.getMixTarifasCombo("Golf");
      tarifarios.forEach((element) => {
        element.value = element.Id;
        element.text = element.Nombre;
      });
      this.tarifarios = tarifarios;
    },

    formatDate(timestamp) {
      let d = new Date(timestamp);
      //console.log(new moment(d))
      //let Creacion =   d.getDate()  + "-" + (d.getMonth()+1) + "-" + d.getFullYear() + " " + d.getHours() + ":" + d.getMinutes();
      return new moment(d).format("DD-MM-YYYY HH:mm");
    },
  },
  computed: {
    reservas_comp() {
      let res = [];
      this.reservations.forEach((ele) => {
        if (ele.Mayorista) {
          let index = this.$_.findIndex(this.hoteles, ["id", ele.Mayorista.Id]);
          ele.NombreHotel = this.hoteles[index].Nombre;
        } else {
          ele.NombreHotel = ele.Departamento;
        }
        if (ele.Cuentas) {
          let totalPagado = 0;
          let totalCancelado = 0;
          let cuentas = Object.entries(ele.Cuentas);
          cuentas.forEach((cuenta) => {
            let totalAccount = 0;
            if (cuenta[0] !== "Extra") {
              let format_date = moment(ele.RF.FI, "YYYY-MM-DD_HH:mm:ss");
              let item = {
                format_date: moment(ele.RF.FI, "YYYY-MM-DD_HH:mm:ss"),
                date_format: format_date.format("DD-MM-YYYY"),
                time_format: format_date.format("HH:mm"),
                creadoEn: ele.Creador.Type,
                mxn: this.$pgsHelper.formatNumber(ele.Totales.MXN),
                usd: this.$pgsHelper.formatNumber(ele.Totales.USD),
                NombreHotel: ele.NombreHotel,
                Concierge: ele.Concierge ? ele.Concierge.Nm : "",
                ConciergeData: ele.Concierge
                  ? this.$pgsHelper.getById(
                      this.concierges,
                      "id",
                      ele.Concierge.Id
                    )
                  : null,
              };

              totalAccount++;
              if (cuenta[1].Estatus === "P") {
                totalPagado = 1;
              }
              if (cuenta[1].Estatus === "C") {
                totalCancelado = 1;
              }
              if (item.ConciergeData) {
                let valorComision =
                  item.ConciergeData.cms.tp == "$"
                    ? item.ConciergeData.cms.vl.C +
                      " " +
                      item.ConciergeData.cms.vl.M
                    : item.ConciergeData.cms.vl;
                item.TipoComision =
                  item.ConciergeData.cms.tp + " " + valorComision;
                item.Comision = { C: 0, M: "MXN" };
                if (cuenta[1].Estatus === "P") {
                  if (item.ConciergeData.cms.tp == "$") {
                    item.Comision = item.ConciergeData.cms.vl;
                  } else {
                    let amount =
                      Number(
                        cuenta[1].Catalogo[0].Pco * item.ConciergeData.cms.vl
                      ) / 100;
                    item.Comision = { C: amount, M: cuenta[1].Catalogo[0].Mnd };
                  }
                }
              } else {
                item.TipoComision = "NA";
                item.Comision = { C: 0, M: "MXN" };
              }
              item.Folio = ele.Folio;
              item.PlayerId = cuenta[1].IdCliente;
              item.Creacion = this.formatDate(ele.FechaCreacion);
              item.playerNombre = cuenta[1].Nombre;
              item.totalAccount = totalAccount;
              item.totalPagado = totalPagado;
              item.totalCancelado = totalCancelado;
              item.Notas = ele.Notas;
              item.Precio = cuenta[1].Catalogo[0].Pco;
              item.Moneda = cuenta[1].Catalogo[0].Mnd;
              item.ConciergeId = ele.Concierge ? ele.Concierge.Id : null;
              item.FolioVenta = cuenta[1].Catalogo[0].FVenta;
              item.Log = ele.__ChangeLog;
              let Tarifario =
                cuenta[1]?.Catalogo[0]?.ExtraParams?.TarifaData?.Tar || null;
              item.Tarifario = Tarifario;
              item.TarifarioName = this.$pgsHelper.getById(
                this.tarifarios,
                "Id",
                Tarifario
              ).Nombre;
              if (cuenta[1].Estatus === "P") {
                item.Estatus = "Pagado";
              } else if (cuenta[1].Estatus === "C") {
                item.Estatus = "Cancelled";
              } else {
                item.Estatus = ele.Estatus;
              }
              res.push(item);
              // if (this.clienteFilter == "All") {
              //   if (this.statusFilter == "All") {
              //     res.push(item);
              //   } else {
              //     if (this.statusFilter == item.Estatus) {
              //       res.push(item);
              //     }
              //   }
              // } else {
              //   if (this.clienteFilter == item.PlayerId) {
              //     if (this.statusFilter == "All") {
              //       res.push(item);
              //     } else {
              //       if (this.statusFilter == item.Estatus) {
              //         res.push(item);
              //       }
              //     }
              //   }
              // }
            }
          });
        }
      });

      // if (this.selectedConcierge != "All") {
      //   filteredConcierges = this.$_.filter(res, (o) => {
      //     return o.ConciergeId == this.selectedConcierge;
      //   });
      // }
      // if (this.TarifarioFilter != "ALL") {
      //   console.log("entre");
      //   let tarifasMatched = this.$_.filter(filteredConcierges, (o) => {
      //     return o.Tarifario == this.TarifarioFilter;
      //   });
      //   return tarifasMatched;
      // }

      return res;
    },
    disableDates() {
      return { to: new Date(this.input_date) };
    },
    departamentos() {
      let deptos = [{ text: "Todos", value: "ALL" }];
      let departamentos = this.$store.getters.getDepartamentos;
      departamentos.forEach((dep) => {
        (dep.text = dep.Nombre), (dep.value = dep.id);
        deptos.push(dep);
      });
      return deptos;
    },
    sumaActual() {
      let total = {
        totalActual: 0,
        totalPotencial: 0,
        apartado: 0,
        noApartado: 0,
      };

      this.times.forEach((hour) => {
        if (hour) {
          total.totalActual += hour.ocupado;
          total.totalPotencial += hour.disponible;
          total.apartado = (total.totalActual / total.totalPotencial) * 100;
          total.noApartado = 100 - total.apartado;
        }
      });
      return total;
    },
  },
  created() {
    this.MainDepartamento = localStorage.getItem("selectedDepartment");
    this.getHoteles();
    this.getConcierges();
    this.getComboTarifarios();
    this.getDaysRules();
  },
};
</script>

<style>
.input input {
  border-bottom: 1px solid black;
  width: 100%;
}
</style>
